<template>
  <div class="container-fluid">
  <div class="row">
      <div class="col-md-12">
          <table-obras :obras='obras' @filterByTag='filterByTag($event)'></table-obras>
      </div>
  </div>
</div>
</template>
<script>

import ObraService from '../services/obra-service'
import { TableObras } from '@/components'
import OverlayService from '../services/overlay-service'

export default {
  components: {
    TableObras
  },
  data () {
    return {
      limit: 10,
      obras: []
    }
  },

  mounted () {
    this.loadObras()
  },

  methods: {
    loadObras () {
      const order = [{ orderBy: 'id', direction: 'desc' }]

      const filter = {
        limit: this.limit,
        orderBy: order
      }

      OverlayService.trigger('show', true)

      ObraService.getByTitle(filter)
        .then(response => response.data)
        .then(data => {
          this.obras = data.data
          this.count = data.total
          OverlayService.trigger('show', false)
        }).catch(er => OverlayService.trigger('show', false))
    }
  }
}
</script>

